module.exports = __webpack_public_path__ + "static/media/error-icon.474b5dcf.svg";